module.exports = __webpack_public_path__ + "static/img/25.f7f96b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/25.png
// module id = DkCB
// module chunks = 35